var _90d_acf_google_map = {

  loadGoogleMapsApi: function() {
  	if(typeof google === "undefined"){
      
      window._90dl_google_maps_api_key = typeof window._90dl_google_maps_api_key === 'undefined' ? 'none' : window._90dl_google_maps_api_key;

  		var script = document.createElement("script");
  		script.src = "https://maps.googleapis.com/maps/api/js?key=" + window._90dl_google_maps_api_key + "&libraries=places&ver=3&callback=_90d_acf_google_map.loadGoogleMapsApiReady";
  		document.getElementsByTagName("head")[0].appendChild(script);
  	} else {
  		loadGoogleMapsApiReady();
  	}
  },

  loadGoogleMapsApiReady: function(){
  	$(window).trigger("google_map_api_ready");
  },

  render_map: function($el) {

    var $markers = $el.find('.marker');

    var args = {
      zoom: 15,
      center: new google.maps.LatLng(0, 0),
      scrollwheel: false,
      mapTypeIds: [google.maps.MapTypeId.ROADMAP]
    };

    var map = new google.maps.Map($el[0], args);
    map.markers = [];

    $markers.each(function() {
      _90d_acf_google_map.add_marker($(this), map);
    });

    if(typeof window.map_tint_colour !== 'undefined' && window.map_tint_colour !== false) {

      map.setOptions({
        styles: [{
          "featureType":"all",
          "elementType":"all",
          "stylers":[
            {"hue":window.map_tint_colour},
            {"saturation":100},
            {"lightness":-10},
            {"gamma":1.1}
          ]
        }]
      });

    }

    //google.maps.event.addListenerOnce(map, 'idle', function(){
      //google.maps.event.trigger(map, 'resize');
      _90d_acf_google_map.center_map(map);
    //});

  },

  add_marker: function($marker, map) {

    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

    var marker_icon = (typeof $marker.attr('data-icon') !== 'undefined') ? $marker.attr('data-icon') : 'http://www.google.com/mapfiles/marker.png';

    var marker = new google.maps.Marker({
      position: latlng,
      map: map,
      animation: google.maps.Animation.DROP,
      icon: marker_icon
    });

    map.markers.push(marker);

  },

  center_map: function(map) {

    var bounds = new google.maps.LatLngBounds();

    $.each(map.markers, function(i, marker) {
      var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      bounds.extend(latlng);
    });

    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom(15);
    } else {
      map.fitBounds(bounds);
    }

  },

};
